import i18n from './i18n';

export default i18n;

export * from './supportedLocales';

export { default as translationsUS } from './translations/en-US/translations.json';
export { default as translationsBR } from './translations/pt-BR/translations.json';

export { userLocaleFetcher } from './localeFetcher';
